<template>
  <div v-if="cart && cart.length > 0">
    <div class="pt-0 cart-wrapper" :style="`max-height: ${maxCartListH}px`">

      <ChooseRefundable v-if="refundableShouldBeChosen" class="d-md-block d-none"/>

      <hr v-if="refundableShouldBeChosen" class="d-md-block d-none"/>

      <div class="order-label mb-2 d-none d-md-block">{{ trans('your_order') }}:</div>

      <div class="fw-bold note-14 pt-2 pt-md-0">
        {{ trans('tickets_of') }}: {{ amountOfTickets }}
        <span v-if="refundableShouldBeChosen && refundable === 1" class="badge badge-success ms-2">{{ trans('refundable_tariff') }}</span>
        <span v-if="refundableShouldBeChosen && refundable === 0" class="badge badge-danger ms-2">{{ trans('nonrefundable_tariff') }}</span>
      </div>

      <div v-for="c in Object.keys(cartSummary)" class="cart-item">
        <div class="row align-items-center">
          <div class="col">
            <div class="section">{{ cartSummary[c].section }}</div>
            <div class="seat">{{ cartSummary[c].seat }}</div>
          </div>
          <div class="col-auto">
            <div class="price">
              {{ cartSummary[c].price * discountedCoefficient | formatNumber }} ₸
              <div v-if="discountedCoefficient < 1"
                   style="text-decoration: line-through; color: #7e8389;font-size: 12px;font-weight: 400;">
                {{ cartSummary[c].price | formatNumber }} ₸
              </div>
            </div>
          </div>
          <div class="col-auto" v-if="(!order || !order.vendor) && !qrCodeImage">
            <a class="pointer"
               @click="initiateDeleteTicket(cartSummary[c])">
              <img src="/images/trashbin.svg" alt="delete"/>
            </a>
          </div>
        </div>
        <div v-if="cartSummary[c].promo_amount > 1" class="text-muted small mt-1">
          {{ transOr('you_will_get', 'Вы получите') }} {{ cartSummary[c].promo_amount }} {{ ticketsWord(cartSummary[c].promo_amount) }}
        </div>
      </div>

      <div class="cart-item border-bottom-0" v-if="serviceFee > 0">
        <div class="row align-items-center">
          <div class="col">{{ trans('service_fee') }}</div>
          <div class="col-auto">
            <template v-if="event && event.external_fee_type === 'percent'">{{ event.external_fee_value | formatNumber }}%</template>
            <template v-else>{{ serviceFee | formatNumber }} ₸</template>
          </div>
        </div>
      </div>

      <div class="cart-item border-bottom-0" v-if="refundableShouldBeChosen && refundable === 1">
        <div class="row align-items-center">
          <div class="col">{{ trans('refundable_fee') }}</div>
          <div class="col-auto">{{ event.refundable_fee | formatNumber }}%</div>
        </div>
      </div>

      <div class="cart-item border-bottom-0" v-if="promocodeDiscount > 0 && step === 3">
        <div class="row align-items-center">
          <div class="col">{{ trans('promocode') }}</div>
          <div class="col-auto text-primary">-{{ promocodeDiscount }}%</div>
        </div>
      </div>

      <div class="cart-item fw-bold border-bottom-0">
        <div class="row align-items-center">
          <div class="col">{{ trans('total') }}</div>
          <div class="col-auto">{{ totalWithFeeAndRefundable | formatNumber }} ₸</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex"
import EventBus from "../../../event-bus"
import RadioGroup from "./RadioGroup.vue"
import ChooseRefundable from "./ChooseRefundable.vue"

export default {
  name: "Cart",
  components: {ChooseRefundable, RadioGroup},
  data() {
    return {
      maxCartListH: 0
    }
  },
  computed: {
    ...mapState([
      'cart',
      'step',
      'order',
      'event',
      'refundable',
      'showMobileDetails',
      'promocodeDiscount',
      'qrCodeImage',
      'timetable'
    ]),
    ...mapGetters(['getCartSum', 'discountedCoefficient', 'refundableShouldBeChosen', 'totalWithFeeAndRefundable']),
    cartSummary() {
      let arr = {}
      let sections = {}
      let pricegroups = {}
      this.cart.forEach((item, index) => {
        if(item.row && item.seat) {
          arr['seat_'+item.seat_id] = {
            order_item_id: item.order_item_id,
            section: this.transName(item.section_name),
            seat: this.trans('row')+': '+item.row+', '+this.trans('seat')+': '+item.seat,
            price: item.price,
            seat_id: item.seat_id,
            section_id: item.section_id,
            min_tickets: item.min_tickets ? item.min_tickets : 1,
            pricegroup_id: null,
            type: 'seats'
          }
          return
        }
        if(item.section_id && !item.pricegroup_id) {
          // console.log(item)
          arr['section_'+item.section_id+'_'+index] = {
            order_item_id: item.order_item_id,
            section: this.transName(item.section_name),
            seat: this.trans('entrance'),
            seat_id: item.ticket_id,
            section_id: item.section_id,
            min_tickets: item.min_tickets ? item.min_tickets : 1,
            pricegroup_id: null,
            price: item.price,
            type: 'enter'
          }
          return
        }
        if(item.pricegroup_id) {
          pricegroups[item.pricegroup_id] = (pricegroups[item.pricegroup_id] ? pricegroups[item.pricegroup_id] : 0) + 1
          for(var i = 1; i <= pricegroups[item.pricegroup_id]; i++) {
            arr['pg_' + item.pricegroup_id+'_'+i] = {
              order_item_id: item.order_item_id,
              section: this.transName(item.pricegroup_name),
              seat: this.transName(item.section_name) || this.trans('entrance'),
              seat_id: null,
              section_id: item.section_id || null,
              min_tickets: item.min_tickets ? item.min_tickets : 1,
              pricegroup_id: item.pricegroup_id,
              price: item.price,
              // topstar pricegroup campaign: 1 position = N separate tickets ("1 + (N - 1)")
              promo_amount: this.timetable?.vendor === 'topstar' ? (item.pricegroup_amount_of_tickets || 1) : 1,
              type: 'pricegroup'
            }
          }
        }
      })
      return arr
    },
    serviceFee() {
      if(!this.event || this.event.external_fee_value <= 0) return 0
      if(this.event.external_fee_type === 'absolute') {
        return Math.round(this.event.external_fee_value * this.cart.length)
      }
      if(this.event.external_fee_type === 'percent') {
        return Math.round(this.event.external_fee_value * this.getCartSum) / 100
      }
      return 0
    },
    amountOfTickets() {
      return (this.cart || []).reduce((a, b) => a + (b?.pricegroup_amount_of_tickets || 1), 0)
    }
  },
  methods: {
    transOr(key, fallback) {
      const str = this.trans(key)
      return str === key ? fallback : str
    },
    ticketsWord(n) {
      const mod10 = n % 10
      const mod100 = n % 100
      if(mod10 === 1 && mod100 !== 11) return this.transOr('ticket_one', 'билет')
      if(mod10 >= 2 && mod10 <= 4 && (mod100 < 10 || mod100 >= 20)) return this.transOr('ticket_few', 'билета')
      return this.transOr('ticket_many', 'билетов')
    },
    async initiateDeleteTicket(c) {
      const q = c.min_tickets > 1 ? c.min_tickets : 1
      if(q === 1) {
        await this.deleteTicket(c)
        return
      }
      const cartSummary = JSON.parse(JSON.stringify(this.cartSummary))
      const tickets = (Object.values(cartSummary)).filter(item => item.section_id === c.section_id)
      tickets.length = Math.min(tickets.length, c.min_tickets)
      const ids = []
      for(const ticket of tickets) {
        await this.deleteTicket(ticket, false)
        ids.push(ticket.order_item_id)
      }
      await axios.post(`/api/order/${this.order.id}/${this.order.hash}/item/delete`, { ids })
      EventBus.$emit('reloadOrder')
    },
    async deleteTicket(c, reload = true) {
      this.$store.commit('updateCart', {
        sign: '-',
        ticket: {
          seat_id: c.type && c.type == 'enter' ? null : c.seat_id,
          section_id: c.section_id,
          pricegroup_id: c.pricegroup_id,
        },
        ignoreGTag: false
      })
      if(c.order_item_id && this.step === 3 && reload) {
        EventBus.$emit('deleteOrderItem', c.order_item_id)
      }
      await this.$nextTick()
      if(!this.cart.length) this.$store.commit('setShowMobileDetails', false)
    },
    calcMaxCart() {
      this.$nextTick(() => {
        // this.maxCartListH = window.innerHeight - this.$refs.topCartHeader.clientHeight - 240
        this.maxCartListH = window.innerHeight - document.getElementById('top-cart-header').clientHeight - 240
      })
    },
  },
  mounted() {
    $('[data-toggle="tooltip"]').tooltip()
    this.calcMaxCart()
    window.addEventListener("resize", this.calcMaxCart)
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calcMaxCart)
  },
  watch: {
    $route() {
      this.$store.commit('setShowMobileDetails', false)
    },
    timetable() {
      this.calcMaxCart()
    },
    step() {
      this.calcMaxCart()
    }
  }

}
</script>

<style scoped lang="scss">
.cart-wrapper {
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
